import { atom } from 'jotai';

export type AlertItem = {
  id: string;
  msg: any;
  alertType: string;
  persistent?: boolean;
  dismissible?: boolean;
};

const initialState: AlertItem[] = [];

export const alertAtom = atom<AlertItem[]>(initialState);
